// The header's breadcrumb: the sidebar section, the screen, then where inside it (a customer's
// name and tab, a month). Screens with names to show set the tail (useBreadcrumb in shell.tsx);
// otherwise the route's own title ends the trail. Pure; tests/unit/breadcrumb.test.ts.
import { NAV_LABELS, navGroupLabel, type NavId } from "../router/route";

export interface Crumb {
  label: string;
  /** Absent on the current page and on section headings. */
  href?: string;
}

export interface TrailInput {
  nav: NavId | null;
  /** The route's title (document title), used when no tail is set. */
  title: string;
  /** Where the nav entry links (its list page), when the principal may open it. */
  navHref: string | null;
  /** The screen's own trail after the nav entry, if it set one. */
  tail: readonly Crumb[] | null;
}

export function breadcrumbTrail({ nav, title, navHref, tail }: TrailInput): Crumb[] {
  if (nav === null) return [{ label: title }];
  const trail: Crumb[] = [];
  const group = navGroupLabel(nav);
  if (group !== null && group !== NAV_LABELS[nav]) trail.push({ label: group });
  const navLabel = NAV_LABELS[nav];
  const rest: Crumb[] = tail ? [...tail] : title !== navLabel ? [{ label: title }] : [];
  if (rest.length > 0 && navHref) trail.push({ label: navLabel, href: navHref });
  else trail.push({ label: navLabel });
  trail.push(...rest);
  const last = trail[trail.length - 1];
  if (last) trail[trail.length - 1] = { label: last.label };
  return trail;
}

/** The document title for a trail: its last two named steps, then the product. */
export function documentTitle(trail: readonly Crumb[]): string {
  const named = trail.slice(-2).map((crumb) => crumb.label);
  return [...named.reverse(), "Nexus by AllCode"].join(" · ");
}
